import ChoosingMonth from "../choosing-month/choosing-month";
import ExportExcelMain from '../export-excel-main/export-excel-main';
import ExportExcelSummary from '../export-excel-summary/export-excel-summary';
import { GroupRequirement, RequirementColumn, Department } from "../../types/data";
import { months } from "../../const";

import { StatusQuestionnaire } from "../../types/data";
import { getCurrentMonthAndYear } from "../../utils/utils";
import { TooltipItem } from "src/utils/Tooltip";

type ActionListProps = {
  year: number;
  setYear: React.Dispatch<React.SetStateAction<number | null>>;
  month: number;
  setMonth: React.Dispatch<React.SetStateAction<number | null>>;
  statusQuestionnaire?: StatusQuestionnaire;
  dataMain: GroupRequirement[] | RequirementColumn[];
  departments?: Department[];
  column: { [key: string]: string | number };
  user?: unknown;
  isNotEditQuestionnaire?: boolean;
  isLockedForAudit?: boolean;
  currentDate: unknown[];
  custom?: boolean;
  isNotAction?: boolean;
  onButtonComplete?: () => void;
  onButtonReturn?: () => void;
};

function ActionList(props: ActionListProps) {
  const { year, setYear, month, setMonth, statusQuestionnaire, user, dataMain, departments, column, currentDate, custom, isNotAction, isNotEditQuestionnaire, isLockedForAudit, onButtonComplete, onButtonReturn } = props;

  const isAuditor = (user as any)?.infoVPO?.zone || (user as any)?.infoVPO?.adminRegion;
  const isShowButtonComplete = statusQuestionnaire !== 'Завершено' && !isNotEditQuestionnaire && (!isLockedForAudit || isAuditor);

  // Получаем актуальную дату завершения опросника
  const finishDate = currentDate.find((item) => item.month === months[month - 1] && item.year === year)?.autoEndDate;

  const isShowButtonReturn =
    statusQuestionnaire === 'Завершено' &&
    (
      (user.infoVPO.user && !user.infoVPO.adminRegion && !user.infoVPO.admin ? false :
        (user.infoVPO.admin && new Date() < new Date(finishDate)) ||
        user.infoVPO.adminRegion
      )
    );

  return (
    <div className="sticky top-[52px] z-30 flex gap-3 bg-[#F3F4F6] py-2">
      <ChoosingMonth
        year={year}
        setYear={setYear}
        month={month}
        setMonth={setMonth}
        custom={custom}
        statusQuestionnaire={statusQuestionnaire}
        currentDate={getCurrentMonthAndYear(currentDate)}
        isNotAction={isNotAction}
      />

      {custom ? (
        <ExportExcelSummary
          data={dataMain as RequirementColumn[]}
          departments={departments as Department[]}
          params={{column}}
        />
      ) : (
        <ExportExcelMain
          data={dataMain as GroupRequirement[]}
          departments={departments as Department[]}
          params={{column}}
        />
      )}

      {!custom && isLockedForAudit && (
        <TooltipItem position="top-left" tooltipsText={'Оценка заблокирована для сотрудников заводов в связи с проведением аудита'}>
          <div className="rounded-md px-6 py-4 h-full shadow-md bg-white border 0 text-gray-700 flex items-center gap-2">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.75 7.75V5.75C13.75 2.98858 11.5114 0.75 8.75 0.75C5.98858 0.75 3.75 2.98858 3.75 5.75V7.75M8.75 12.25V14.25M5.55 18.75H11.95C13.6302 18.75 14.4702 18.75 15.112 18.423C15.6765 18.1354 16.1354 17.6765 16.423 17.112C16.75 16.4702 16.75 15.6302 16.75 13.95V12.55C16.75 10.8698 16.75 10.0298 16.423 9.38803C16.1354 8.82354 15.6765 8.3646 15.112 8.07698C14.4702 7.75 13.6302 7.75 11.95 7.75H5.55C3.86984 7.75 3.02976 7.75 2.38803 8.07698C1.82354 8.3646 1.3646 8.82354 1.07698 9.38803C0.75 10.0298 0.75 10.8698 0.75 12.55V13.95C0.75 15.6302 0.75 16.4702 1.07698 17.112C1.3646 17.6765 1.82354 18.1354 2.38803 18.423C3.02976 18.75 3.86984 18.75 5.55 18.75Z" stroke="#F89090" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </TooltipItem>
      )}

      {!custom && isShowButtonComplete && (user as any)?.email && (
        <button type="button"
          className="rounded-md px-6 py-4 shadow-md bg-[#012169] text-white"
          onClick={onButtonComplete}
        >
          Завершить оценку
        </button>
      )}

      {custom
        ?
          null
        :
          isShowButtonReturn && user.email && (
            <button type="button"
              className="rounded-md px-6 py-4 shadow-md bg-white text-[#012169]"
              onClick={onButtonReturn}
            >
              Вернуть в работу
            </button>
          )
      }
    </div>
  );
}

export default ActionList;
